module.exports = "/_next/static/videos/seller-3-b31cfcf8171b8d4b65384b3d95a1d0d0.mp4";